import { ChartConfig } from '@/components/ui/chart'
import { TimeRange } from '@/types'

export type Range = TimeRange

export type DataType =
  | 'price'
  | 'marketCap'
  | 'totalSupply'
  | 'yield'
  | 'priceBTC'

export const chartConfig = {
  desktop: {
    label: 'Desktop',
    color: 'hsl(var(--card))',
  },
} satisfies ChartConfig

// Light dashed secondary line for the DEX "Market Price" overlay — distinct
// from the green/red NAV performance line. Tweak freely (designer's call).
export const MARKET_PRICE_STROKE = '#8AA9DE'

const now = Math.floor(Date.now() / 1_000)
export const currentHour = Math.floor(now / 3_600) * 3_600
const startOfYear = Math.floor(Date.UTC(new Date().getUTCFullYear(), 0, 1) / 1_000)

export const historicalConfigs: Record<
  Range,
  { to: number; from: number; interval: '1h' | '1d' }
> = {
  '24h': { to: currentHour, from: currentHour - 86_400, interval: '1h' },
  '7d': { to: currentHour, from: currentHour - 604_800, interval: '1h' },
  '1m': { to: currentHour, from: currentHour - 2_592_000, interval: '1h' },
  '3m': { to: currentHour, from: currentHour - 7_776_000, interval: '1d' },
  ytd: { to: currentHour, from: startOfYear, interval: '1d' },
  '1y': { to: currentHour, from: currentHour - 31_536_000, interval: '1d' },
  all: { to: currentHour, from: 0, interval: '1d' },
}
